export default __webpack_public_path__ + "static/media/share_fb_en.0e7b7e95.gif";